module.exports = __webpack_public_path__ + "images/174_4096.jpg";